import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// Configuration fournie par l'utilisateur
const firebaseConfig = {
  apiKey: "AIzaSyCHKHCfx4HDw0d1Dj5pc0CtlEQAXmKwRkg",
  authDomain: "com-example-vigilus-1a2f3.firebaseapp.com",
  projectId: "com-example-vigilus-1a2f3",
  storageBucket: "com-example-vigilus-1a2f3.firebasestorage.app",
  messagingSenderId: "401026469874",
  appId: "1:401026469874:web:6fd5f460c3f7796ed8a56b"
};

// Initialisation de Firebase
const app = initializeApp(firebaseConfig);

// Exports pour l'utilisation dans App.js
export const db = getFirestore(app);
export const auth = getAuth(app);
